import React from 'react';

export function hasRenderableNode(node: React.ReactNode): boolean {
  if (node === null || node === undefined || typeof node === 'boolean') {
    return false;
  }

  if (typeof node === 'string') {
    return node.trim().length > 0;
  }

  if (typeof node === 'number') {
    return true;
  }

  if (Array.isArray(node)) {
    return node.some((child) => hasRenderableNode(child));
  }

  if (React.isValidElement(node)) {
    if (node.type === React.Fragment) {
      const nodeProps = node.props as { children?: React.ReactNode };
      const children = nodeProps.children;
      if (children === null || children === undefined) {
        return false;
      }
      return hasRenderableNode(children);
    }
    return true;
  }

  return React.Children.count(node) > 0;
}
